(function ($) {
	'use strict';

	$(function () {
		function resetKeyEvents($offcanvasLinks) {
			$offcanvasLinks.off('keydown');
		}

		function setKeyEvents($offcanvasLinks) {
			$offcanvasLinks.last().on('keydown', (e) => {
				if (e.key === 'Tab' && !e.shiftKey) {
					$offcanvas.removeClass(activeClass);
					$body.removeClass(bodyActiveClass);
					$trigger.first().focus();
				}
			});

			$offcanvasLinks.first().on('keydown', (e) => {
				if (e.key === 'Tab' && e.shiftKey) {
					$offcanvas.removeClass(activeClass);
					$body.removeClass(bodyActiveClass);
					$trigger.first().focus();
				}
			});
		}

		const activeClass = 'site-offcanvas--is-active';
		const bodyActiveClass = 'offcanvas-is-active';

		const $trigger = $('.js-site-offcanvas-trigger');
		const $offcanvas = $('.js-site-offcanvas');
		const $subMenuTriggers = $('.js-offcanvas-menu-trigger');
		const $body = $('body');

		let $offcanvasLinks = $('.offcanvas-menu__link:visible,.site-offcanvas__link:visible');

		const getOffcanvasLinks = debounce(function () {
			$offcanvasLinks = $('.offcanvas-menu__link:visible,.site-offcanvas__link:visible');
			resetKeyEvents($offcanvasLinks);
			setKeyEvents($offcanvasLinks, $trigger);
		}, 250);

		window.addEventListener('resize', getOffcanvasLinks);

		$trigger.on('click', function () {
			const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
			document.documentElement.style.setProperty('--body-scrollbar-width', `${scrollbarWidth}px`);

			$offcanvas.toggleClass(activeClass);
			$body.toggleClass(bodyActiveClass);
		});

		$trigger.on('keydown', (e) => {
			if (e.key === 'Enter' || e.code === 'Space') {
				setTimeout(function () {
					$offcanvasLinks.first().focus();
				}, 50);
			}
		});

		$subMenuTriggers.on('click', function (e) {
			$(this).toggleClass('is-active');
			const $firstChildLink = $(this).parent().find('.offcanvas-menu-submenu li').first().find('a').first();

			setTimeout(function () {
				$firstChildLink.focus();
			}, 100);
		});

		setKeyEvents($offcanvasLinks);
	});
})(jQuery);
